import * as React from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';

interface IProps {
    numberOfPages: number;
    activePage: number;
    maxNumberOfButtons: number;

    onPageSelect: (page: number) => void;
}

const Pagination = (props: IProps) => {
    let pages: number[] = [];
    const minPage = Math.max(props.activePage - 2, 1);
    let maxPage =
        props.activePage < Math.ceil(props.maxNumberOfButtons / 2)
            ? props.maxNumberOfButtons
            : Math.min(props.activePage + 2, props.numberOfPages);
    maxPage = props.numberOfPages < props.maxNumberOfButtons ? props.numberOfPages : maxPage;

    for (let i = minPage; i <= maxPage; ++i) {
        pages.push(i);
    }

    return (
        <BootstrapPagination>
            <BootstrapPagination.First onClick={() => props.onPageSelect(1)} />
            <BootstrapPagination.Prev
                onClick={() =>
                    props.onPageSelect(props.activePage - 1 < 1 ? 1 : props.activePage - 1)
                }
            />
            {props.activePage !== 1 &&
                props.numberOfPages > props.maxNumberOfButtons &&
                !pages.includes(1) && (
                    <>
                        <BootstrapPagination.Item onClick={() => props.onPageSelect(1)}>
                            1
                        </BootstrapPagination.Item>
                        <BootstrapPagination.Ellipsis />
                    </>
                )}
            {pages.map((page: number, i: number) => (
                <BootstrapPagination.Item
                    key={`pageination-button-${i}`}
                    active={props.activePage === page}
                    onClick={() => props.onPageSelect(page)}
                >
                    {page}
                </BootstrapPagination.Item>
            ))}
            {props.activePage !== props.numberOfPages &&
                props.numberOfPages > props.maxNumberOfButtons &&
                !pages.includes(props.numberOfPages) && (
                    <>
                        <BootstrapPagination.Ellipsis />
                        <BootstrapPagination.Item
                            onClick={() => props.onPageSelect(props.numberOfPages)}
                        >
                            {props.numberOfPages}
                        </BootstrapPagination.Item>
                    </>
                )}
            <BootstrapPagination.Next
                onClick={() =>
                    props.onPageSelect(
                        props.activePage + 1 > props.numberOfPages
                            ? props.numberOfPages
                            : props.activePage + 1
                    )
                }
            />
            <BootstrapPagination.Last onClick={() => props.onPageSelect(props.numberOfPages)} />
        </BootstrapPagination>
    );
};

export default Pagination;
